import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'
import CloseSvg from 'assets/svgr-icons/Close.svg'
import PlaySvg from 'assets/svgr-icons/Play.svg'

export const Card = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background-color: ${COLORS.white};
  border: 1px solid ${COLORS.borderColor};
  border-radius: ${RADII.field};
`

export const PlayButton = styled.button<{ $disabled?: boolean }>`
  position: relative;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  border-radius: 50%;
  background-color: ${COLORS.primaryExtraLight};
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
`

export const PlayIcon = styled(PlaySvg)`
  width: 14px;
  height: 14px;
`

export const NameRow = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 2px;
`

// Stand-in "stop" icon shown while playing (no dedicated square asset exists).
export const StopSquare = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 1px;
  background-color: ${COLORS.primaryDark};
`

// Circular playback progress drawn along the button's edge. Rotated so it
// starts filling from the top and runs clockwise.
export const ProgressRing = styled.svg`
  position: absolute;
  inset: 0;
  transform: rotate(-90deg);
  pointer-events: none;
`

export const ProgressTrack = styled.circle`
  fill: none;
  stroke: ${COLORS.primaryExtraLight};
  stroke-width: 2;
`

export const ProgressIndicator = styled.circle`
  fill: none;
  stroke: ${COLORS.primaryDark};
  stroke-width: 2;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.1s linear;
`

export const RemoveButton = styled.button`
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`

export const CloseIcon = styled(CloseSvg)`
  width: 18px;
  height: 18px;
  fill: ${COLORS.secondarySemiLight};
  transition: fill 0.15s ease;

  ${RemoveButton}:hover & {
    fill: ${COLORS.secondarySemiDark};
  }
`
